import React, { useState, useEffect, useCallback } from 'react';
import { ExpandBtnRight } from '@modules/insights/guideDrawer';
import './leadingPractice.scss';
import classnames from 'classnames';
import { Button, Form, Spin } from 'antd';
import RichEditor from '@modules/questionnaires/complexity/richEditor';
import EditLeadingPracticeList from '@modules/insights/maturityAssessment/leadingPractice/editLeadingPracticeList';
import { useSelector } from 'react-redux';
import { API } from '@service';

const LeadingPracticeFormKey = 'leadingPracticeInfo';

function LeadingPractice({ onExpandChange, expand }) {
  const [isEditing, setIsEditing] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const projectId = useSelector((state) => state.common.currentId);
  const [form] = Form.useForm();
  const isClient = JSON.parse(window.localStorage.userInfo || '{}')?.isClient;

  useEffect(() => {
    if (!projectId || !expand || loading || data.length) {
      return;
    }
    fetchDetail(projectId);
  }, [projectId, expand]);

  const fetchDetail = useCallback((projectId) => {
    setLoading(true);
    API.getLeadingPracticeData(projectId)
      .then((result) => {
        setData(result);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);
  const saveData = useCallback(
    (data) => {
      if (!projectId || !data) {
        return;
      }
      setLoading(true);
      API.saveLeadingPracticeData(projectId, data)
        .then((result) => {
          setIsEditing(false);
          fetchDetail(projectId);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [projectId],
  );

  const onEditBtnClick = useCallback(() => {
    setIsEditing(true);
    setTimeout(() => {
      form.setFieldsValue({
        [LeadingPracticeFormKey]: data,
      });
    }, 100);
  }, [data]);

  const onSave = useCallback(() => {
    form
      .validateFields()
      .then((result) => {
        saveData(result);
      })
      .catch((result) => {
        if (result.errorFields && result.errorFields?.length) {
          // eslint-disable-next-line no-unused-vars
          const scrollToError = document
            .querySelector('.ant-form-item-explain')
            ?.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'center',
            });
        }
      });
  }, []);

  return (
    <div className={classnames('leading-practice', { collapsed: !expand })}>
      <ExpandBtnRight
        isExpand={expand}
        handleToggleExpand={onExpandChange}
        text="Leading Practice"
      />
      <header>
        <h3>Leading Practices</h3>
        <div className="role-control">
          {isEditing ? (
            <>
              <Button
                className="cancel-btn"
                onClick={() => {
                  form.resetFields();
                  setIsEditing(false);
                }}
              >
                cancel
              </Button>
              <Button type="primary" onClick={onSave}>
                save
              </Button>
            </>
          ) : (
            <>
              <Button type="primary" onClick={onEditBtnClick} loading={loading}>
                edit
              </Button>
            </>
          )}
        </div>
      </header>
      <Spin spinning={loading} wrapperClassName="competency-item-list">
        {isEditing ? (
          <EditLeadingPracticeList
            form={form}
            formListName={LeadingPracticeFormKey}
          />
        ) : (
          data.map((i) => (
            <div className="competency-item" key={i.id}>
              <div className="competency-item-title">{i.title}</div>
              <RichEditor
                readOnly
                onInitialContentChange={i.id}
                value={i.content}
                linkPopoverProps={{
                  placement: 'leftTop',
                }}
                // autoSize={{ minRows: 3, maxRows: 3 }}
                // style={{ resize: 'none' }}
              />
            </div>
          ))
        )}
      </Spin>
    </div>
  );
}

export default LeadingPractice;
